import { FC } from 'react';
import * as React from 'react';
import 'twin.macro';
import 'styled-components/macro';

import { UserProfile as UserProfileType } from 'types/graphql';

export interface UserProfileProps
  extends Pick<UserProfileType, 'avatar' | 'display_name' | 'slug'>,
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {}

export const UserProfile: FC<UserProfileProps> = ({ avatar, display_name, slug, ...props }) => (
  <div tw="flex flex-col items-center text-center" {...props}>
    {avatar && <img alt="Profile" src={avatar} tw="rounded-full mb-3 h-20 w-20" />}
    <div tw="display-4 break-words w-full">{display_name}</div>
    {slug && <div tw="text-lg text-gray-50">@{slug}</div>}
  </div>
);
